/* This file was generated automatically. Do not edit manually. */

export enum SmsUsaRegistrationBusinessIndustry {
    Automotive = 'Automotive',
    Agriculture = 'Agriculture',
    Banking = 'Banking',
    Construction = 'Construction',
    Consumer = 'Consumer',
    Education = 'Education',
    Engineering = 'Engineering',
    Energy = 'Energy',
    OilAndGas = 'OilAndGas',
    FastMovingConsumerGoods = 'FastMovingConsumerGoods',
    Financial = 'Financial',
    Fintech = 'Fintech',
    FoodAndBeverage = 'FoodAndBeverage',
    Government = 'Government',
    Healthcare = 'Healthcare',
    Hospitality = 'Hospitality',
    Insurance = 'Insurance',
    Legal = 'Legal',
    Manufacturing = 'Manufacturing',
    Media = 'Media',
    Online = 'Online',
    ProfessionalServices = 'ProfessionalServices',
    RawMaterials = 'RawMaterials',
    RealEstate = 'RealEstate',
    Religion = 'Religion',
    Retail = 'Retail',
    Jewelry = 'Jewelry',
    Technology = 'Technology',
    Telecommunications = 'Telecommunications',
    Transportation = 'Transportation',
    Travel = 'Travel',
    Electronics = 'Electronics',
    NotForProfit = 'NotForProfit',
}
